import api from './client';

export const tasksApi = {
  list: (params) => api.get('/tasks', { params }),
  my: () => api.get('/tasks/my'),
  summary: () => api.get('/tasks/summary'),
  get: (id) => api.get('/tasks/' + id),
  getForRecord: (recordId) => api.get('/tasks/record/' + recordId),
  create: (data) => api.post('/tasks', data),
  createBulk: (data) => api.post('/tasks/bulk', data),
  update: (id, data) => api.put('/tasks/' + id, data),
  complete: (id, data) => api.put('/tasks/' + id + '/complete', data || {}),
  reopen: (id) => api.put('/tasks/' + id + '/reopen'),
  delete: (id) => api.delete('/tasks/' + id),
  // Templates
  getTemplates: (params) => api.get('/tasks/templates/list', { params }),
  createTemplate: (data) => api.post('/tasks/templates', data),
  updateTemplate: (id, data) => api.put('/tasks/templates/' + id, data),
  deleteTemplate: (id) => api.delete('/tasks/templates/' + id),
  applyTemplate: (data) => api.post('/tasks/apply-template', data),
  // Comments
  getComments: (taskId) => api.get('/tasks/' + taskId + '/comments'),
  addComment: (taskId, content) => api.post('/tasks/' + taskId + '/comments', { content }),
  deleteComment: (taskId, commentId) => api.delete('/tasks/' + taskId + '/comments/' + commentId),
  // Status
  setStatus: (taskId, status, note) => api.put('/tasks/' + taskId + '/status', { status, note }),
  // Attachments
  getAttachments: (taskId) => api.get('/tasks/' + taskId + '/attachments'),
  uploadAttachment: (taskId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/tasks/' + taskId + '/attachments', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
  deleteAttachment: (taskId, attId) => api.delete('/tasks/' + taskId + '/attachments/' + attId),
};
